export const LANGUAGE_STORAGE_KEY = "coi_public_language";

export const PUBLIC_LANGUAGES = [
  { code: "en", label: "English", short: "EN", dir: "ltr" },
  { code: "ar", label: "العربية", short: "AR", dir: "rtl" },
  { code: "ku", label: "کوردی", short: "KU", dir: "rtl" },
];

export const getLanguageMeta = (code) =>
  PUBLIC_LANGUAGES.find((lang) => lang.code === code) || PUBLIC_LANGUAGES[0];

export const isSupportedLanguage = (code) =>
  PUBLIC_LANGUAGES.some((lang) => lang.code === code);
